import React, { useEffect, useState } from "react";
import { getPendingDealerList, getAllInternalUsers, toggleDealerStatus } from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";

const PendingDealerList = () => {
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const [pendingRes, internalRes] = await Promise.all([
        getPendingDealerList(),
        // getAllInternalUsers(),
      ]);

      const pendingList = pendingRes?.data || [];
      const internalList = internalRes?.Data || [];

      const dealerUsers = internalList.filter(
        (u) => u.usertype?.toLowerCase() === "dealer"
      );

      const mergedMap = new Map();

      pendingList.forEach((d) => {
        mergedMap.set(d.id, d);
      });

      dealerUsers.forEach((u) => {
        if (!mergedMap.has(u.id)) {
          mergedMap.set(u.id, {
            id: u.id,
            username: u.username || "",
            first_name: u.first_name || u.username || "",
            last_name: u.last_name || "",
            email: u.email || "",
            mobile: u.mobile || "",
            firmname: u.firmname || "",
            date_joined: u.date_joined || u.created_at || "",
            extra1: u.extra1 || "",
            is_active: u.is_active ?? false,
          });
        }
      });

      setDealers(Array.from(mergedMap.values()));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const toggleActive = async (dealerId) => {
    setDealers((prev) =>
      prev.map((d) =>
        d.id === dealerId ? { ...d, is_active: !d.is_active } : d
      )
    );
    try {
      await toggleDealerStatus(dealerId);
      showSnackbar("success", "Dealer status updated");
      fetchDealers();
    } catch (error) {
      setDealers((prev) =>
        prev.map((d) =>
          d.id === dealerId ? { ...d, is_active: !d.is_active } : d
        )
      );
      showSnackbar("error", "Failed to toggle dealer status");
    }
  };

  // Declare filteredDealers before using it
  const filteredDealers = dealers.filter((d) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      d.firmname?.toLowerCase().includes(term) ||
      d.username?.toLowerCase().includes(term) ||
      d.first_name?.toLowerCase().includes(term) ||
      d.last_name?.toLowerCase().includes(term) ||
      d.email?.toLowerCase().includes(term) ||
      d.mobile?.includes(term)
    );
  });

  const totalPages = Math.ceil(filteredDealers.length / pageSize);

  const paginatedDealers = filteredDealers.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  if (loading) {
    return <p style={styles.loading}>Loading...</p>;
  }

  if (!dealers || dealers.length === 0) {
    return <p style={styles.noData}>No dealers found.</p>;
  }

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Dealer List</h3>
      <input
        type="text"
        placeholder="Search"
        style={styles.search}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <table style={styles.table}>
        <thead>
          <tr>
            {/* <th style={styles.th}>ID</th>
            <th style={styles.th}>User-ID</th> */}
            <th style={styles.th}>Firm Name</th>
            <th style={styles.th}>First Name</th>
            {/* <th style={styles.th}>Last Name</th> */}
            <th style={styles.th}>Email</th>
            <th style={styles.th}>Mobile</th>
            <th style={styles.th}>Joined Date</th>
            <th style={styles.th}>GST</th>
            <th style={styles.th}>Status</th>
          </tr>
        </thead>
        <tbody>
          {paginatedDealers.map((d, index) => (
            <tr
              key={d.id}
              style={{
                ...styles.tr,
                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
              }}
            >
              {/* <td style={styles.td}>{d.id}</td>
              <td style={styles.td}>{d.id}</td> */}
              <td style={styles.td}>{d.firmname || "-"}</td>
              <td style={styles.td}>{d.first_name}</td>
              {/* <td style={styles.td}>{d.last_name || "-"}</td> */}
              <td style={styles.td}>{d.email}</td>
              <td style={styles.td}>{d.mobile}</td>
              <td style={styles.td}>
                {d.date_joined ? new Date(d.date_joined).toLocaleDateString() : "-"}
              </td>
              <td style={styles.td}>{d.extra1 || "-"}</td>
           <td style={styles.td}>
  <label className="switch">
    <input
      type="checkbox"
      checked={d.usertype !== "Customer" && d.is_active}
      onChange={() => toggleActive(d.id)}
    />
    <span className="slider"></span>
  </label>
</td> 
            </tr>
          ))}
        </tbody>
      </table>
      {/* Pagination controls */}
      <div style={styles.paginationContainer}>
        <div style={styles.pageSelectContainer}>
          <select
            style={styles.pageSelect}
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >
            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
        <div style={styles.pageButtonsContainer}>
          <button
            style={styles.pageButton}
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>
          <span style={styles.pageCount}>
            {page} / {totalPages || 1}
          </span>
          <button
            style={styles.pageButton}
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

// Styles object
const styles = {
  container: {
    margin: "2rem",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    marginBottom: "1rem",
    color: "#005487",
  },
  search: {
    padding: "8px 12px",
    marginBottom: "1rem",
    width: "200px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  th: {
    padding: "12px",
    backgroundColor: "#005487",
    color: "white",
    textAlign: "left",
  },
  tr: {
    borderBottom: "1px solid #ddd",
    transition: "background-color 0.3s",
  },
  td: {
    padding: "12px",
    color: "#555",
  },
  loading: {
    textAlign: "center",
    marginTop: "2rem",
  },
  noData: {
    textAlign: "center",
    marginTop: "2rem",
  },
  paginationContainer: {
    marginTop: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  pageSelectContainer: {
    color: "black",
  },
  pageSelect: {
    padding: "8px 12px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  pageButtonsContainer: {
    display: "flex",
    alignItems: "center",
  },
  pageButton: {
    marginRight: "0.5rem",
    padding: "8px 12px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "white",
    cursor: "pointer",
  },
  pageCount: {
    margin: "0 1rem",
  },
};

export default PendingDealerList;